import { render } from "./OAuthMultiConnect.vue?vue&type=template&id=2ecdbffb&ts=true"
import script from "./OAuthMultiConnect.vue?vue&type=script&lang=ts"
export * from "./OAuthMultiConnect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/connect-widgets/connect-widgets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__